export default "__VITE_ASSET__DdOjOjim__"